interface PricingOptionsInterface {
    pricingCacheMaxAge? : string;
    httpProtocol? :string;
    cacheControlTimestamp? :string ;
    isLoggedIn?:boolean;
    pricingApiTimeout? :string;
    buildDate? :string;
    pricingApi? :string;
    magellanPricingApiPath? :string;
    comergentHost? : string;
}

export class PricingOptionsModel implements PricingOptionsInterface{

    pricingCacheMaxAge : string = '43200';
    httpProtocol :string ='';
    cacheControlTimestamp :string = '20180119';
    isLoggedIn:boolean = false;
    pricingApiTimeout :string = '10000';
    buildDate :string = '';
    comergentHost: string = '';
    magellanPricingApiPath: string = '/api/magellan/pricing/';
    pricingApi :string;

    constructor(options: PricingOptionsInterface) {
        Object.keys(options).forEach(key => {
            if(options[key]) this[key] = options[key];
        })

        this.pricingApi = this.httpProtocol + this.comergentHost + this.magellanPricingApiPath;
    }

    getHeaders(): unknown {
        const headers = { 'Cache-Control': this.isLoggedIn ? 'no-cache' : 'max-age=' + this.pricingCacheMaxAge };
        return {headers};
    }

    getCacheVersionParams(): string {
        return "time=" + this.cacheControlTimestamp + "&build=" + this.buildDate;
    }
}
